import React from "react";
import Banner from "../../components/banner/Banner";
import Title from "../../components/titles/Title";
import "./EcoEntrepreneur.css";
import EcoEntrepreneurBenefits from "./EcoEntrepreneurBenefits";
import CTA from "../../components/CTA/CTA";
import ProfitGeneratingServices from "./ProfitGeneratingServices";
import CategoryProducts from "../../components/CategoryProducts/CategoryProducts";
import AGN from "../../assets/images/technology-icons/asset-governance.svg";
// EcoEntrepreneur Component
const EcoEntrepreneur = () => {
  return (
    <>
      {/* Banner Section */}
      <Banner
        className="eco-entreprenur-bg"
        bannerTitle={[
          <span key="1">
            Embark on your earning journey by monetizing unutilized{" "}
          </span>,
          <br key="2" className="d-none d-md-block"></br>,
          <span key="3">
            beekeeping capacity and become sustainability catalyst
          </span>,
        ]}
      />

      {/* Category Products Section - Monetizing Services */}
      <CategoryProducts
        btn1text="Apply Now"
        categoryId={["AGR12-1012"]}
        title="Monetizing Services"
        description="Services not found"
        price="false"
        subcategory="true"
      />

      {/* Services Section */}
      <div className="container">
        {/* Title for Services */}
        <Title classname="text-center mb-5" heading="Services" />
        {/* Component that lists Profit Generating Services */}
        <ProfitGeneratingServices />
      </div>

      {/* Benefits Section */}
      <div className="section-container benefit-container">
        <div className="container">
          {/* Title for Benefits */}
          <Title classname="text-center mb-5" heading="Benefits" />
          {/* Component that lists Eco-Entrepreneur Benefits */}
          <EcoEntrepreneurBenefits />
        </div>
      </div>

      {/* Our Technology Section */}
      <div className="section-container benefit-container">
        <div className="container">
          <div className="section-sub-container text-center">
            {/* Title for Technology Section */}
            <Title classname="text-center mb-4" heading="Our Technology" />

            {/* Technology Icon */}
            <img
              className="technoloy-icons d-block mb-2 mx-auto mt-4"
              src={AGN}
              alt="Asset Governance Network"
            />

            {/* Technology Title */}
            <h5 className="mb-3">Asset Governance Network (AGN)</h5>

            {/* Description about Asset Governance Network */}
            <p>
              The Asset Governance Network in an Agri Asset Management context
              is a comprehensive system for managing agricultural assets in a
              sustainable, socially responsible, and governance-compliant way.
              By aligning practices with ESG goals, such companies can create
              value not just for their investors, but also for the environment
              and society at large. It ensures long-term sustainability, reduces
              risks, and positions the company as a leader in the emerging field
              of sustainable agriculture.
            </p>

            {/* Related roles in AGN */}
            <p>
              Agent, AgriMiner, Eco-Entrepreneur, Operator, QA, Executive,
              Production Manager
            </p>
          </div>
        </div>
      </div>

      {/* Call To Action Section */}
      <CTA
        title="Want to become Eco-entrepreneur to earn extra income"
        href="https://siapischain-abn.gbrapp.com/auth/undefined/signup"
        buttonText="Register Now"
      />
    </>
  );
};

export default EcoEntrepreneur;



